import React from "react";
import PropTypes from "prop-types";

import { Select } from "rbx";

function SelectInput({
  name,
  value,
  handleChange,
  disabled,
  options,
  // valueFn,
  displayFn,
  size
}) {
  return (
    <Select.Container size={size}>
      <Select
        disabled={disabled}
        name={name}
        value={value}
        onChange={handleChange}
      >
        {options.map((option, i) => (
          <Select.Option key={i} value={displayFn(option)}>
            {displayFn(option)}
          </Select.Option>
        ))}
      </Select>
    </Select.Container>
  );
}
SelectInput.propTypes = {
  options: PropTypes.array,
  size: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  displayFn: PropTypes.func
  // valueFn: PropTypes.func
};
SelectInput.defaultProps = {
  options: []
};

export default SelectInput;
